import(/* webpackMode: "eager", webpackExports: ["AuthSessionProvider"] */ "/home/runner/work/infra-idp-app/infra-idp-app/apps/auth-iframe-app-new/src/app/contexts/auth-session-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IframeMessagingProvider"] */ "/home/runner/work/infra-idp-app/infra-idp-app/apps/auth-iframe-app-new/src/app/contexts/iframe-messaging-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UrqlProvider"] */ "/home/runner/work/infra-idp-app/infra-idp-app/apps/auth-iframe-app-new/src/app/contexts/urql-context.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/infra-idp-app/infra-idp-app/apps/auth-iframe-app-new/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/infra-idp-app/infra-idp-app/node_modules/@fontsource/inter/index.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/infra-idp-app/infra-idp-app/node_modules/@fontsource/pretendard/index.css");
